import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Button, InsidePageWrapper, OutsidePageWrapper, SimpleImage } from "@parkschannel/ui";
import { FifthTip, SecondTip, SeventhTip, SixthTip, ThirdTip, TipHeading, TipText } from "../../Upload";
import { signIn } from "next-auth/react";
import { useConfig } from "../../Config/ConfigContext";
import { useAuth } from "../../Auth/AuthContext";
import { useButtonsAnalytics } from "../../../utils";
const headingStyles = "mb-0 text-base lg:text-xl";
export const GuidelinesPage = ()=>{
    useButtonsAnalytics();
    const config = useConfig();
    const { useSession  } = useAuth();
    const { data: session  } = useSession();
    return /*#__PURE__*/ _jsx("div", {
        className: "bg-white",
        children: /*#__PURE__*/ _jsx(OutsidePageWrapper, {
            children: /*#__PURE__*/ _jsxs(InsidePageWrapper, {
                className: "mb-[56px] lg:mt-[70px]",
                children: [
                    /*#__PURE__*/ _jsx("h1", {
                        className: "text-3xl mb-8 text-neutral-900 font-bold lg:mb-[72px] lg:text-[40px]",
                        children: "Video Guidelines"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-10",
                        children: [
                            /*#__PURE__*/ _jsxs("article", {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "relative w-[50px] h-[50px] mb-3 ",
                                        children: /*#__PURE__*/ _jsx(SimpleImage, {
                                            src: "/media/illustrations/bulb.webp",
                                            alt: "Light bulb",
                                            fill: true,
                                            className: "object-contain"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(TipHeading, {
                                        className: headingStyles,
                                        children: "We’re excited to have you join our Parks Channel creator community!"
                                    }),
                                    /*#__PURE__*/ _jsx(TipText, {
                                        children: "Our goal is to create the most entertaining and informative video destination for parks content – and we can only do it with your help! The best videos will earn the chance to win Parks Channel swag, and when you decide to become a regular contributor, more opportunities will follow. We believe in rewarding great content!"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(SecondTip, {
                                headingClassName: headingStyles
                            }),
                            /*#__PURE__*/ _jsx(ThirdTip, {
                                headingClassName: headingStyles
                            }),
                            /*#__PURE__*/ _jsxs("article", {
                                children: [
                                    /*#__PURE__*/ _jsx(TipHeading, {
                                        className: headingStyles,
                                        children: "Make it pretty"
                                    }),
                                    /*#__PURE__*/ _jsx(TipText, {
                                        children: "Shoot and edit something beautiful and exciting. You’ve got a whole movie studio in your smartphone!"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(FifthTip, {
                                headingClassName: headingStyles
                            }),
                            /*#__PURE__*/ _jsx(SixthTip, {
                                headingClassName: headingStyles
                            }),
                            /*#__PURE__*/ _jsx(SeventhTip, {
                                headingClassName: headingStyles
                            }),
                            /*#__PURE__*/ _jsxs("article", {
                                children: [
                                    /*#__PURE__*/ _jsx(TipHeading, {
                                        className: headingStyles,
                                        children: "Send high quality material"
                                    }),
                                    /*#__PURE__*/ _jsxs(TipText, {
                                        children: [
                                            "Send us the full-resolution video file, with no compression. We want the highest quality we can get, and will compress on our side as needed.",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(TipText, {
                                        children: "It’s so easy to contribute. Now create your user profile and get started!"
                                    })
                                ]
                            })
                        ]
                    }),
                    session ? null : /*#__PURE__*/ _jsx(Button, {
                        variant: "outline",
                        onClick: ()=>signIn("cognito", {
                                callbackUrl: "".concat(config.pageUrl, "/videos/new")
                            }),
                        className: "mt-10",
                        children: "Sign In to submit a video"
                    })
                ]
            })
        })
    });
};
